import dayjs from '@/plugins/dayjs';

const TYPE_ICONS = {
    'verification-submitted': 'icon-buy',
    'verification-approved': 'icon-check-double',
    'verification-rejected': 'icon-clock',
    'transaction-started': 'icon-buy',
    'transaction-canceled': 'icon-close',
    'transaction-completed': 'icon-checkbox',
    'transaction-rejected': 'icon-close',
    'transaction-payment-error': 'icon-close',
};

export default class NotificationModel {
    constructor(id, createdAt, invoice, isRead, type) {
        this.id = id;
        this.createdAt = new Date(createdAt);
        this.invoice = invoice;
        this.isRead = isRead;
        this.type = type;
    }

    static createFromData({ id, createdAt, invoice, isRead, type }) {
        return new this(id, createdAt, invoice, isRead, type);
    }

    getHumanizedCreatedAt(locale?: string): string {
        const d = locale ? dayjs(this.createdAt).locale(locale) : dayjs(this.createdAt);
        return d.fromNow();
    }

    getCreatedAtDate(locale?: string): string {
        const d = locale ? dayjs(this.createdAt).locale(locale) : dayjs(this.createdAt);
        return d.format('DD MMMM YYYY');
    }

    getCreatedAtTime() {
        return dayjs(this.createdAt).format('HH:mm');
    }

    getIconClass() {
        return TYPE_ICONS[this.type] || '';
    }
}
